import { render, staticRenderFns } from "./navjdgj.vue?vue&type=template&id=ae231e4a&scoped=true&"
import script from "./navjdgj.vue?vue&type=script&lang=js&"
export * from "./navjdgj.vue?vue&type=script&lang=js&"
import style0 from "./navjdgj.vue?vue&type=style&index=0&id=ae231e4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae231e4a",
  null
  
)

export default component.exports